<template>
  <footer class="site-footer">

    <div class="footer-content">
      <div class="footer-details content-full-width flex flex-start">
          <img src="/images/logo.png" class="footer-logo">

          <div class="address flex">
              <div class="flex">
                  <img src="/images/footer-mark.png" class="desktop">
                  <span v-html="address"></span>
              </div>


              <div class="copyright desktop">
                  © ETCOR. All rights reserved
              </div>
          </div>

          <div class="contacts">
              <ul>
                  <li><a :href="'mailto:' + email"><img src="/images/footer-mail.png">
                      Send us an email</a></li>
                  <li><a :href="'tel:' + phone"><img src="/images/footer-phone.png">{{ phoneurl }}</a></li>
              </ul>
          </div>

          <div class="social desktop">
              <ul>
                  <li><a :href="facebook" v-show="facebook" target="_blank"><img src="/images/facebook.svg"> facebook</a></li>
                  <li><a :href="youtube" v-show="youtube" target="_blank"><img src="/images/youtube.svg"> Youtube</a></li>
                  <li><a :href="twitter" v-show="twitter" target="_blank"><img src="/images/twitter.svg"> Twitter</a></li>
                  <li><a :href="instagram" v-show="instagram" target="_blank"><img src="/images/instagram.svg"> Instagram</a></li>
                  <li><a :href="linkedin" v-show="linkedin" target="_blank"><img src="/images/linkedin.svg"> Linkedin</a></li>
              </ul>
          </div>

          <div class="social mobile">
              <ul>
                  <li><a :href="facebook" v-show="facebook" target="_blank"><img src="/images/facebook.svg"></a></li>
                  <li><a :href="youtube" v-show="youtube" target="_blank"><img src="/images/youtube.svg"></a></li>
                  <li><a :href="twitter" v-show="twitter" target="_blank"><img src="/images/twitter.svg"></a></li>
                  <li><a :href="instagram" v-show="instagram" target="_blank"><img src="/images/instagram.svg"></a></li>
                  <li><a :href="linkedin" v-show="linkedin" target="_blank"><img src="/images/linkedin.svg"></a></li>
              </ul>
          </div>

          <div class="copyright mobile">
              © ETCOR. All rights reserved
          </div>




      </div>
    </div>

    <!--<div class="footer-legal">
      <div class="content-max-width flex">



        <a
          href="https://www.innowebitech.com"
          target="_blank"
          class="attribution"
        >
          Powered by Innowebitech
        </a>

      </div>
    </div>-->

  </footer>
</template>

<script>
export default {
    props:  ['address', 'phoneurl', 'phone', 'email', 'facebook', 'linkedin', 'instagram', 'youtube', 'twitter'],
  computed: {
    year () {
      return new Date().getFullYear()
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Footer.vue